import { InstallAppTip } from '@/components/shared/InstallAppTip';

interface Props {
  onSignIn: () => void;
  hasSession?: boolean;
}

export function InviteOnlyGate({ onSignIn, hasSession }: Props) {
  return (
    <div className="flex min-h-screen items-center justify-center p-6 text-ink">
      <div className="w-full max-w-sm text-center">
        <div className="mb-12">
          <div className="font-serif text-3xl font-bold tracking-widest mb-2">BAG TAG</div>
          <div className="text-xs text-mute italic">
            Independent app for golf members.<br />
            Not affiliated with any country club.
          </div>
        </div>

        <InstallAppTip className="mb-6 text-left" />

        <div className="mb-8 space-y-3 text-left">
          <h2 className="font-serif text-xl font-bold text-navy">Invite only</h2>
          <p className="text-sm leading-relaxed text-slate-600">
            Bag Tag is a private club app. Ask a member to send you an invitation from inside the app.
          </p>
          <ul className="list-disc space-y-1.5 pl-5 text-sm text-slate-600">
            <li>Your invite email includes a personal link — open it on the phone or browser you&apos;ll use daily.</li>
            <li>That link walks you through username, Venmo, and handicap setup.</li>
            <li>Visiting bagtag.club directly won&apos;t show a public sign-up form.</li>
          </ul>
          {hasSession ? (
            <p className="rounded-xl bg-gold/15 p-3 text-sm text-navy">
              You&apos;re signed in but haven&apos;t finished setup. Open your invitation link again to complete your profile.
            </p>
          ) : (
            <p className="text-sm text-slate-500">
              Your invite email includes a link to create your account and join the club.
            </p>
          )}
        </div>

        <button
          type="button"
          onClick={onSignIn}
          className="text-sm font-semibold text-navy underline underline-offset-2"
        >
          Already set up? Sign in
        </button>
      </div>
    </div>
  );
}
